export default __webpack_public_path__ + "static/media/icon_policy_overview_bottom2_mobile.dd9cbb32.svg";